import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
import { registerServiceWorker, reloadIfUpdatePending } from '@/lib/pwa'
import { router } from '@/routes'
import '@/styles/globals.css'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('#root element not found')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

registerServiceWorker()

let lastLocationKey = router.state.location.key
router.subscribe((state) => {
  if (state.location.key === lastLocationKey) return
  lastLocationKey = state.location.key
  reloadIfUpdatePending()
})
